var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('v-select',_vm._g(_vm._b({},'v-select',_vm.$attrs,false),_vm.events)):_c('v-autocomplete',_vm._g(_vm._b({},'v-autocomplete',_vm.$attrs,false),_vm.events))}
var staticRenderFns = []

export { render, staticRenderFns }